/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Subscription_ExpiredInputs */

const cs_api_error_subscription_expired = /** @type {(inputs: Api_Error_Subscription_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předplatné vypršelo. Pro úpravy obnovte plán.`)
};

const en_api_error_subscription_expired = /** @type {(inputs: Api_Error_Subscription_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription has expired. Upgrade your plan to make changes.`)
};

/**
* | output |
* | --- |
* | "Your subscription has expired. Upgrade your plan to make changes." |
*
* @param {Api_Error_Subscription_ExpiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_subscription_expired = /** @type {((inputs?: Api_Error_Subscription_ExpiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Subscription_ExpiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_subscription_expired(inputs)
	return cs_api_error_subscription_expired(inputs)
});